<template>
  <component
    :is="card ? 'q-card' : 'q-item'"
    :class="card ? 'rounded-borders-20 q-pa-sm' : undefined"
    :style="{
      'background': paymentMethodBrandsBgColor(defaultPaymentMethodBrand),
      'max-width': card ? '400px' : undefined,
      'min-height': card ? '230px' : undefined,
    }"
  >
    <component
      :is="card ? 'q-card-section' : 'q-item-section'"
      :avatar="!card"
      :class="card ? 'text-right' : undefined"
    >
      <q-icon
        :style="{ color: paymentMethodBrandsColor(defaultPaymentMethodBrand) }"
        :name="paymentMethodBrandsIcon(defaultPaymentMethodBrand)"
        :size="card ? 'lg' : 'sm'"
      />
    </component>
    <component
      :is="card ? 'q-card-section' : 'q-item-section'"
      class="text-left text-black"
      :class="card ? 'q-mt-md' : undefined"
    >
      <div
        v-if="card"
        class="text-body1"
        :style="{
          color: paymentMethodBrandsColor(defaultPaymentMethodBrand),
          'text-shadow': card ? '0 0 1px rgba(0, 0, 0, 0.1)' : undefined
        }"
      >
        {{ $_.startCase(defaultPaymentMethodBrand) }}
      </div>
      <component
        :is="card ? 'div' : 'q-item-label'"
        class="text-body1 text-bold"
        :style="{
          color: paymentMethodBrandsColor(defaultPaymentMethodBrand),
          'text-shadow': card ? '0 0 1px rgba(0, 0, 0, 0.1)' : undefined
        }"
      >
        <template v-if="card">
          <span class="q-pr-md">* * * *</span>
          <span class="q-pr-md">* * * *</span>
          <span class="q-pr-md">* * * *</span>
        </template>
        <template v-else>
          {{ $_.startCase(defaultPaymentMethodBrand) }} ending
        </template>
        {{ defaultPaymentMethodLast4 }}
      </component>
      <slot name="message" />
    </component>
    <slot name="action" />
  </component>
</template>
<script>
import { PAYMENT_CARD_PROVIDER } from 'src/models/payment/Payment'

const PAYMENT_CARD_PROVIDER_COLOR = {
  VISA: '#1434cb',
  MASTERCARD: '#EB001B',
  AMEX: '#006fcf',
  DISCOVER: '#ec6b29',
  JCB: '#008eed',
  DINERS: 'diners-club',
  DEFAULT: '#dfe4ea'
}
export default {
  name: 'DefaultPaymentMethodBrand',
  props: {
    card: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultPaymentMethodBrand: {
      type: String,
      required: true,
      default: null
    },
    defaultPaymentMethodLast4: {
      type: String,
      required: true,
      default: null
    }
  },
  created () {
    _.extend(this, { PAYMENT_CARD_PROVIDER })
  },
  methods: {
    paymentMethodBrandsBgColor (cardType) {
      if (this.card) return PAYMENT_CARD_PROVIDER_COLOR.DEFAULT
      if (cardType === PAYMENT_CARD_PROVIDER.VISA) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.VISA, 90)
      } else if (cardType === PAYMENT_CARD_PROVIDER.MASTERCARD) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.MASTERCARD, 60)
      } else if (cardType === PAYMENT_CARD_PROVIDER.AMEX) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.AMEX, 90)
      } else if (cardType === PAYMENT_CARD_PROVIDER.DISCOVER) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.DISCOVER, 90)
      } else {
        return this.$lightenColor('#000000', 90)
      }
    },
    paymentMethodBrandsColor (cardType) {
      if (cardType === PAYMENT_CARD_PROVIDER.VISA) {
        return PAYMENT_CARD_PROVIDER_COLOR.VISA
      } else if (cardType === PAYMENT_CARD_PROVIDER.MASTERCARD) {
        return PAYMENT_CARD_PROVIDER_COLOR.MASTER
      } else if (cardType === PAYMENT_CARD_PROVIDER.AMEX) {
        return PAYMENT_CARD_PROVIDER_COLOR.AMEX
      } else if (cardType === PAYMENT_CARD_PROVIDER.DISCOVER) {
        return PAYMENT_CARD_PROVIDER_COLOR.DISCOVER
      } else {
        return '#000'
      }
    },
    paymentMethodBrandsIcon (cardType) {
      const cardTypes = PAYMENT_CARD_PROVIDER
      if (_.includes(cardTypes, cardType)) {
        return `fab fa-cc-${cardType}`
      }
      return 'fal fa-credit-card'
    }
  }
}
</script>
